/**
 * File → Settings (decision 0017): opt-in usage statistics, and the automatic backup.
 */
import { useState, type ReactNode } from 'react';
import type { Translate } from '@elec/i18n';
import type { Platform } from '@elec/platform';
import { legalUrl } from './cloud.ts';
import { setUsage, usageEnabled } from './usage.ts';
import { Dialog } from './ui.tsx';

export function SettingsDialog(props: {
  t: Translate;
  platform: Platform;
  locale: string;
  /** More sections (the automatic backup). */
  children?: ReactNode;
  onClose(): void;
}) {
  const { t, platform } = props;
  const [usage, setUsageState] = useState(() => usageEnabled(platform));
  return (
    <Dialog
      title={t('settings.title')}
      onClose={props.onClose}
      actions={<button onClick={props.onClose}>{t('dialog.close')}</button>}
    >
      <label className="check">
        <input
          type="checkbox"
          checked={usage}
          onChange={(e) => {
            setUsage(platform, e.target.checked);
            setUsageState(e.target.checked);
          }}
          data-testid="settings-usage"
        />
        <span>{t('settings.usage')}</span>
      </label>
      <p className="muted small">
        {t('settings.usageHint')}{' '}
        <button className="link" onClick={() => void platform.openUrl(legalUrl('privacy', props.locale))}>
          {t('settings.privacy')}
        </button>
      </p>
      {props.children}
    </Dialog>
  );
}
